
<template>
  <v-app id="searchArrq">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>ARES requests</v-card-title> <v-btn v-if="addArrq === 'Yes'" class="primary ma-2" small @click="newArrq()">Add</v-btn><br>
      <v-simple-table dense>
         <tbody v-for="(arrqRecord,i) in searchArrq" :key="i">
           <!-- <tr @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)"> -->
           <tr>
             <td  @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)">{{arrqRecord.arrq_nr}}</td>
             <td  @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)">{{arrqRecord.arrq_indien_dat}}</td>
             <td  @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)">{{arrqRecord.arrq_prio}}</td>
             <td  @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)">{{arrqRecord.arrq_oms_kort}}</td>
             <td  @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)">{{arrqRecord.gebr_indien_naam}}</td>
              <td  @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)">{{arrqRecord.gebr_dev_naam}}</td>
             <td  @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)">{{arrqRecord.arrq_status}}</td>
             
             <td><v-btn v-if="arrqRecord.arrq_arrow_up" @click="moveUp(arrqRecord.arrq_encrid)" text icon ><v-icon small>mdi-arrow-up</v-icon></v-btn></td>
             <td><v-btn v-if="arrqRecord.arrq_arrow_down" @click="moveDown(arrqRecord.arrq_encrid)" text icon ><v-icon small>mdi-arrow-down</v-icon></v-btn></td>
             <td  @click="$router.reload('/syst/ref/arrq/onArrq/' + arrqRecord.arrq_encrid)">{{arrqRecord.arrq_stat_dat}}</td>
          </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>   
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchArrq: [],
      addArrq: 'No'
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/arrq/searchArrq.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchArrq"
          },
          searchArrq: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchArrq = res.data.searchArrq;
            this.addArrq = res.data.arrq_add;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    newArrq() { 
      this.$axios
        .post("ares/json/ares/syst/ref/arrq/addArrq.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addArrq"
          },
          addArrq: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            setTimeout(() => { this.$router.reload('/syst/ref/arrq/searchArrq'); }, 2000);   
          }
        })
    },
    moveUp(arrq_encrid) { 
      this.$axios
        .post("ares/json/ares/syst/ref/arrq/moveArrqUp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "moveArrqUp"
          },
          moveArrqUp: {
            arrq_encrid: arrq_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$router.reload('/syst/ref/arrq/searchArrq');   
          }
        })
    },
    moveDown(arrq_encrid) { 
      this.$axios
        .post("ares/json/ares/syst/ref/arrq/moveArrqDown.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "moveArrqDown"
          },
          moveArrqDown: {
            arrq_encrid: arrq_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$router.reload('/syst/ref/arrq/searchArrq');   
          }
        })
    }
  }    
};

</script> 
